var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRestaurants = function SvgRestaurants(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.975 340.95C306.663 340.95 348.565 299.048 348.565 247.36C348.565 195.672 306.663 153.77 254.975 153.77C203.287 153.77 161.385 195.672 161.385 247.36C161.385 299.048 203.287 340.95 254.975 340.95Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.975 372.62C324.154 372.62 380.235 316.539 380.235 247.36C380.235 178.181 324.154 122.1 254.975 122.1C185.796 122.1 129.715 178.181 129.715 247.36C129.715 316.539 185.796 372.62 254.975 372.62Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M450.325 410.83V77.79C449.215 70.43 442.765 65.06 435.515 65.28C428.585 65.49 422.645 70.77 421.605 77.79C416.805 108.44 413.345 144.41 413.565 184.64C413.725 215.05 415.955 242.83 419.185 267.49C427.655 267.49 436.125 267.51 444.585 267.51H431.185C424.655 315.27 418.125 363.05 411.595 410.83C409.965 423.68 419.785 434.45 430.415 434.72C441.375 435.01 451.955 424.11 450.325 410.83Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.085 410.83C99.715 423.68 89.895 434.45 79.265 434.72C68.305 435.01 57.725 424.11 59.355 410.83L72.635 267.5H87.955L98.095 410.83H98.085Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.505 69.8799L50.575 183.49L51.785 185.13C58.875 194.77 70.135 200.47 82.105 200.47C94.075 200.47 105.335 194.78 112.425 185.13L113.635 183.49L114.705 69.8799",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.615 69.8801L50.575 183.49L81.195 147.49V69.8701",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.835 200.46H73.195V267.5H87.835V200.46Z",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.635 183.49L81.195 147.49",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurants);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/restaurants.svg";